module.exports = __webpack_public_path__ + "static/media/copy.f434d5d4.png";